import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { H6 } from "./H6Block";
import { defaultData } from "./H6BlockDefaultData";
import { meta } from "./H6BlockMetaData";

export const H6Block: BlockExport = {
  type: "component",
  Block: H6,
  imagePreview: {
    type: "icon",
    name: "24-builder-ui-element-heading",
    size: 24,
  },
  defaultData,
  meta,
};
